const PARENT_CHECKOUT_PATH = '/checkout';
const SANDBOX_MODE = process.env.NEXT_PUBLIC_SANDBOX_MODE !== 'false';

const parentPlans = [
    {
        planKey: 'times_tables',
        checkoutId: 'times_tables',
        legacyId: 'times_tables',
        displayName: 'Times Tables',
        legacyName: 'Times Tables',
        priceAmount: '99.99',
        currencyCode: 'USD',
        billingInterval: 'month',
        billingIntervalCount: 3,
        durationLabel: '3 months',
        legacyDuration: '3 months',
        recurring: true,
        trialLabel: 'Free 7-day trial',
        seatLabel: '1 child account',
        ctaPath: PARENT_CHECKOUT_PATH,
        isActive: true,
        showOnParentCheckout: true,
        background: 'bg-pricing-background-times-tables',
        marketingBullets: [
            'Access to Times Tables module',
            'Self-paced quizzing',
            'Progress tracking',
        ],
        monthlyCostCopy: '(billed every 3 months)',
        stripePriceId: SANDBOX_MODE ? 'price_1RC4hCJCkvkbxYUrKA9FmDX2' : 'price_1RDonmJCkvkbxYUrKfJMDWxU',
        paypalPlanId: SANDBOX_MODE ? 'P-8B002688N3682770AM73NM3Y' : 'P-91F376285T3919216M76TWJQ',
        legacyStripePriceId: SANDBOX_MODE ? 'price_1RC4hCJCkvkbxYUrKA9FmDX2' : 'price_1PgTQkJCkvkbxYUr0SM71Y7y',
        legacyPaypalPlanId: SANDBOX_MODE ? 'P-8B002688N3682770AM73NM3Y' : 'P-24B361596W6748911M2UTPOA',
        legacyPriceLabel: '$99.99',
    },
    {
        planKey: 'core_annual',
        checkoutId: 'core-annual',
        legacyId: 'annual-all-access-no-times-tables',
        displayName: 'Core Math Success',
        legacyName: 'Annually',
        priceAmount: '105.99',
        currencyCode: 'USD',
        billingInterval: 'year',
        billingIntervalCount: 1,
        durationLabel: 'Year',
        legacyDuration: 'year',
        recurring: true,
        trialLabel: 'Free 7-day trial',
        seatLabel: '1 child account',
        ctaPath: PARENT_CHECKOUT_PATH,
        isActive: true,
        showOnParentCheckout: true,
        background: 'bg-pricing-background-mini-pack',
        marketingBullets: [
            'All Muzology content except Times Tables',
            'Self-paced quizzing',
            'Progress tracking',
        ],
        monthlyCostCopy: 'only $8.83/month (billed annually)',
        stripePriceId: SANDBOX_MODE ? 'price_1RC4fCJCkvkbxYUrnG1kAy19' : 'price_1RDmxCJCkvkbxYUrItPFoCLF',
        paypalPlanId: SANDBOX_MODE ? 'P-7GD50293BM623464JM73NLOI' : 'P-3RP814687R944301FM76Q7WA',
        legacyStripePriceId: SANDBOX_MODE ? 'price_1RC4fCJCkvkbxYUrnG1kAy19' : 'price_1P3P1NJCkvkbxYUr6Uvq0BgE',
        legacyPaypalPlanId: SANDBOX_MODE ? 'P-7GD50293BM623464JM73NLOI' : 'P-2HA45753DG383363SM6IPXBY',
        legacyPriceLabel: '$105.99/year',
        legacySavings: 'SAVE 37%',
        legacySavingsMobile: 'SAVE 37%',
        legacyNoticeText2: 'Cancel easily any time.',
    },
    {
        planKey: 'math_mastery',
        checkoutId: 'math-mastery',
        legacyId: 'annual-all-access',
        displayName: 'Complete Math Mastery',
        legacyName: 'Annually',
        priceAmount: '109.99',
        currencyCode: 'USD',
        billingInterval: 'year',
        billingIntervalCount: 1,
        durationLabel: 'Year',
        legacyDuration: 'year',
        recurring: true,
        trialLabel: 'Free 7-day trial',
        seatLabel: '1 child account',
        ctaPath: PARENT_CHECKOUT_PATH,
        isActive: true,
        showOnParentCheckout: true,
        background: 'bg-pricing-background-all-access',
        marketingBullets: [
            'All Muzology content including Times Tables',
            'Self-paced quizzing',
            'Progress tracking',
        ],
        monthlyCostCopy: 'only $9.16/month (billed annually)',
        stripePriceId: SANDBOX_MODE ? 'price_1RC4eBJCkvkbxYUrMtcImkCs' : 'price_1RDmypJCkvkbxYUrVZM12wHf',
        paypalPlanId: SANDBOX_MODE ? 'P-6RA42006WP5741358M73NKOQ' : 'P-43X46398L1607594NM76RA7A',
        legacyStripePriceId: SANDBOX_MODE ? 'price_1RC4eBJCkvkbxYUrMtcImkCs' : 'price_1P3P1NJCkvkbxYUr6Uvq0BgE',
        legacyPaypalPlanId: SANDBOX_MODE ? 'P-6RA42006WP5741358M73NKOQ' : 'P-2HA45753DG383363SM6IPXBY',
        legacyPriceLabel: '$109.99/year',
        legacySavings: 'SAVE 37%',
        legacySavingsMobile: 'SAVE 37%',
        legacyNoticeText2: 'Cancel easily any time.',
    },
    {
        planKey: 'summer_slide',
        checkoutId: 'summer-slide',
        legacyId: null,
        displayName: 'Summer Slide',
        legacyName: null,
        priceAmount: '109.99',
        currencyCode: 'USD',
        billingInterval: 'year',
        billingIntervalCount: 1,
        durationLabel: 'Year',
        legacyDuration: 'year',
        recurring: true,
        trialLabel: 'Free 7-day trial',
        seatLabel: '1 child account',
        ctaPath: '/summer-slide-checkout',
        isActive: true,
        showOnParentCheckout: false,
        background: 'bg-pricing-background-all-access',
        marketingBullets: [
            'All Muzology content including Times Tables',
            'Self-paced quizzing',
            'Progress tracking',
        ],
        monthlyCostCopy: 'only $9.16/month (billed annually)',
        stripePriceId: SANDBOX_MODE ? 'price_1RC4eBJCkvkbxYUrMtcImkCs' : 'price_1RDmypJCkvkbxYUrVZM12wHf',
        paypalPlanId: SANDBOX_MODE ? 'P-6RA42006WP5741358M73NKOQ' : 'P-43X46398L1607594NM76RA7A',
        legacyStripePriceId: null,
        legacyPaypalPlanId: null,
        legacyPriceLabel: null,
    },
];

function toAmountLabel(priceAmount) {
    return `$${priceAmount}`;
}

function toLegacyPlan(plan) {
    return {
        id: plan.legacyId,
        name: plan.legacyName,
        amount: toAmountLabel(plan.priceAmount),
        duration: plan.legacyDuration,
        recurring: plan.recurring,
        savings: plan.legacySavings,
        savings_mobile: plan.legacySavingsMobile,
        price: plan.legacyPriceLabel,
        priceId: plan.legacyStripePriceId,
        paypalPlanID: plan.legacyPaypalPlanId,
        notice_text2: plan.legacyNoticeText2,
    };
}

function toCheckoutPlan(plan, index) {
    return {
        id: plan.checkoutId,
        planKey: plan.planKey,
        checkoutIndex: index,
        name: plan.displayName,
        price: plan.priceAmount,
        amount: toAmountLabel(plan.priceAmount),
        duration: plan.durationLabel,
        background: plan.background,
        bullets: plan.marketingBullets,
        priceId: plan.stripePriceId,
        paypalPlanID: plan.paypalPlanId,
        recurring: plan.recurring,
        monthly_cost_copy: plan.monthlyCostCopy,
        ctaPath: plan.ctaPath,
        isActive: plan.isActive,
        showOnParentCheckout: plan.showOnParentCheckout,
    };
}

const checkoutParentPlans = parentPlans.map((plan, index) => toCheckoutPlan(plan, index));
const legacyParentPlans = parentPlans
    .filter((plan) => Boolean(plan.legacyId))
    .map((plan) => toLegacyPlan(plan));

function getParentPlanByKey(planKey) {
    return parentPlans.find((plan) => plan.planKey === planKey) ?? null;
}

function getCheckoutParentPlans() {
    return checkoutParentPlans;
}

function getLegacyParentPlans() {
    return legacyParentPlans;
}

function getCheckoutSelectionPlans() {
    return checkoutParentPlans.filter((plan) => plan.showOnParentCheckout !== false);
}

function getCheckoutParentPlanByIndex(index) {
    return checkoutParentPlans[index] ?? null;
}

function getCheckoutParentPlanByKey(planKey) {
    return checkoutParentPlans.find((plan) => plan.planKey === planKey) ?? null;
}

function getCheckoutParentPlanByStripePriceId(priceId) {
    return checkoutParentPlans.find((plan) => plan.priceId === priceId) ?? null;
}

function getLegacyParentPlanByStripePriceId(priceId) {
    return legacyParentPlans.find((plan) => plan.priceId === priceId) ?? null;
}

function getParentPlanByAnyPlanId(planId) {
    return parentPlans.find((plan) => (
        plan.stripePriceId === planId
        || plan.legacyStripePriceId === planId
        || plan.paypalPlanId === planId
        || plan.legacyPaypalPlanId === planId
    )) ?? null;
}

module.exports = {
    parentPlans,
    getParentPlanByKey,
    getParentPlanByAnyPlanId,
    getCheckoutParentPlans,
    getCheckoutSelectionPlans,
    getCheckoutParentPlanByIndex,
    getCheckoutParentPlanByKey,
    getCheckoutParentPlanByStripePriceId,
    getLegacyParentPlans,
    getLegacyParentPlanByStripePriceId,
};
